// @ts-ignore
import EventEmitter from 'events';

export interface BridgeOptions {
  send: (mes: string) => void;
  onMessage: (fn: (mes: string) => void) => () => void;
}
export interface Event {
  channel: string;
  // 消息id,组成：${pid}-${消息数目id}
  messageId: string;
  data: any;
}
export type IHandle = (data: any, event: Event) => any | undefined;

export default class Bridge {
  private eventEmit = new EventEmitter();

  private pid = 'popo';

  private AutoIncreaseId = 0;

  private _send: BridgeOptions['send'];

  private handleChannelMap = new Set();

  private offMessage: (() => void) | null = null;

  constructor({ send, onMessage }: BridgeOptions) {
    // eslint-disable-next-line no-underscore-dangle
    this._send = send;
    this.offMessage = onMessage(this.messageHandle.bind(this));
  }

  send(channel: string, data?: any, messageId?: string) {
    const obj = this.genMessageData(channel, data, messageId);
    // eslint-disable-next-line no-underscore-dangle
    this._send(JSON.stringify(obj));
    return obj;
  }

  on(channel: string, fn: IHandle) {
    this.eventEmit.on(channel, fn);
  }

  off(channel: string, fn: IHandle) {
    this.eventEmit.off(channel, fn);
  }

  once(channel: string, fn: IHandle) {
    this.eventEmit.once(channel, fn);
  }

  invoke(channel: string, data: any) {
    return new Promise((resolve, reject) => {
      const obj = this.send(channel, data);
      const { messageId } = obj;
      this.once(`${channel}_${messageId}`, data => {
        if (data.err) {
          reject(data.err);
        } else {
          resolve(data.data);
        }
      });
    });
  }

  handle(channel: string, fn: (...args: any[]) => any) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    this.handleChannelMap.add(channel);
    function handleFn(data: any, event: Event) {
      let result: any;
      try {
        result = fn(data, event);
        Promise.resolve(result)
          .then(res => {
            self.send(`${channel}_${event.messageId}`, { data: res });
          })
          .catch(err => {
            self.send(`${channel}_${event.messageId}`, { err });
          });
      } catch (err: any) {
        self.send(`${channel}_${event.messageId}`, { err: err.message });
      }
    }
    this.eventEmit.removeAllListeners(channel);
    this.on(channel, handleFn);
  }

  destroyMessage() {
    this.offMessage?.();
  }

  private genMessageData(channel: string, data: any, messageId?: string) {
    messageId = messageId || `${this.pid}-${this.AutoIncreaseId}`;
    this.AutoIncreaseId += 1;
    const obj: Event = {
      channel,
      messageId,
      data,
    };
    return obj;
  }

  private messageHandle(message: string) {
    let obj: Event;
    if (typeof message === 'string') {
      try {
        obj = JSON.parse(message);
      } catch (err) {
        throw new Error(`JSON parser Error:${message}`);
      }
      const { channel, data, messageId } = obj;
      if (this.eventEmit.eventNames().includes(channel)) {
        this.eventEmit.emit(channel, data, obj);
      } else if (!data.err) {
        this.send(`${channel}_${messageId}`, { err: `通信进程不存在handle事件：${channel}` });
      }
    }
  }
}

/* demo
const iframeBridge = new Bridge({
  onMessage(fn: (mes: string) => void): void {
    window.addEventListener('message', (message) => {
      console.log(message);
      fn(message.data);
    }, false);
  },
  send: (message) => {
    window.parent.postMessage(message, '*');
  },
});

const parentBridge = new Bridge({
  onMessage(fn: (mes: string) => void): void {
    window.addEventListener('message', (message) => {
      console.log(message);
      fn(message.data);
    }, false);
  },
  send: (message) => {
    iframe.currentwindow.postMessage(message, '*');
  },
}); */
